import { cn } from "@marketing-sites/utils/cn";
import ColumnChartIcon from "./surge-icons/column-chart.svg";
import FinIcon from "./surge-icons/fin.svg";
import HomeSpaceIcon from "./surge-icons/home-space.svg";
import InboxIcon from "./surge-icons/inbox.svg";
import IntercomIcon from "./surge-icons/intercom.svg";
import KnowledgeIcon from "./surge-icons/knowledge.svg";
import ContactsIcon from "./surge-icons/multiple-people.svg";
import OutboundIcon from "./surge-icons/outbound-filled.svg";
import SettingsIcon from "./surge-icons/settings.svg";

// Mirrors the teammate app's collapsed PrimaryNav (Surge): classic item order,
// Surge's own icons and its rail metrics, so the demo reads as the real inbox.
const NAV_ITEMS = [
  { key: "operator", Icon: HomeSpaceIcon },
  { key: "inbox", Icon: InboxIcon },
  { key: "fin", Icon: FinIcon },
  { key: "knowledge", Icon: KnowledgeIcon },
  { key: "reports", Icon: ColumnChartIcon },
  { key: "outbound", Icon: OutboundIcon },
  { key: "contacts", Icon: ContactsIcon },
];

function NavItem({
  Icon,
  active,
}: {
  Icon: typeof InboxIcon;
  active?: boolean;
}) {
  return (
    <span className="flex h-8 w-full items-center px-1.5">
      <span
        className={cn(
          "flex h-8 w-full items-center rounded-[8px] pl-1",
          active &&
            "bg-white shadow-[0px_1px_4px_0px_rgba(20,20,20,0.15)] ring-1 ring-[#e9eae6]",
        )}
      >
        <span className="flex size-6 items-center justify-center">
          <Icon className="size-4" />
        </span>
      </span>
    </span>
  );
}

export function NavRail({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        "hidden w-11 shrink-0 flex-col pb-2 pt-5 text-[#1a1a1a] sm:flex",
        className,
      )}
    >
      <span className="mb-4 flex h-9 items-center justify-center">
        <IntercomIcon className="size-6" />
      </span>
      <span className="flex flex-col gap-1">
        {NAV_ITEMS.map(({ key, Icon }) => (
          <NavItem key={key} Icon={Icon} active={key === "inbox"} />
        ))}
      </span>
      <span className="mt-auto flex flex-col gap-1">
        <NavItem Icon={SettingsIcon} />
        <span className="flex h-8 items-center px-2.5">
          <span className="size-6 rounded-full bg-[#d9c7a8]" />
        </span>
      </span>
    </div>
  );
}
